export default __webpack_public_path__ + "static/media/penink03.dd0bdf6d.png";